import { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { PawPrint, Smartphone, ArrowRight } from "lucide-react";
import { LogoMark } from "@/components/Logo";

const LABELS = { u: "questo profilo", cane: "questa scheda cane", partner: "questo partner" };

export default function DeepLink() {
  const location = useLocation();
  const segment = location.pathname.split("/")[1];
  const kind = LABELS[segment] || "questo contenuto";
  const [attempted, setAttempted] = useState(false);

  useEffect(() => {
    const appUrl = `fuffyfam:/${location.pathname}${location.search}`;
    const timer = setTimeout(() => setAttempted(true), 1600);
    window.location.href = appUrl;
    return () => clearTimeout(timer);
  }, [location]);

  return (
    <div
      className="min-h-screen bg-[#F9F8F6] text-[#1A1A1A] flex flex-col items-center justify-center px-6 text-center"
      data-testid="deeplink-page"
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.85, rotate: -8 }}
        animate={{ opacity: 1, scale: 1, rotate: 0 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      >
        <LogoMark className="w-20 h-20" />
      </motion.div>

      <motion.h1
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
        data-testid="deeplink-title"
        className="font-display font-extrabold mt-8 text-3xl sm:text-5xl tracking-tight leading-tight max-w-xl"
      >
        {attempted ? (
          <>Non hai ancora <span className="text-[#FF6B35]">l'app?</span></>
        ) : (
          <>Apertura di <span className="text-[#FF6B35]">FuffyFam</span>…</>
        )}
      </motion.h1>

      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.3, ease: [0.16, 1, 0.3, 1] }}
        className="mt-5 text-base sm:text-lg text-[#5C5C5C] leading-relaxed max-w-md"
      >
        {attempted
          ? `L'app FuffyFam è in arrivo su iOS e Android. Lascia la tua email e ti avviseremo al lancio: poi ${kind} si aprirà direttamente nell'app.`
          : `Stiamo aprendo ${kind} nell'app. Se non succede nulla, l'app potrebbe non essere installata.`}
      </motion.p>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.45, ease: [0.16, 1, 0.3, 1] }}
        className="mt-10 flex flex-col sm:flex-row items-center gap-4"
      >
        <motion.div whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }}>
          <Link
            to="/#unisciti"
            data-testid="deeplink-waitlist-button"
            className="flex items-center gap-2 bg-[#FF6B35] hover:bg-[#E55A2B] text-white font-semibold rounded-full px-7 py-3.5 transition-colors duration-300"
          >
            <PawPrint className="w-4 h-4" />
            Unisciti alla lista d'attesa
          </Link>
        </motion.div>
        <motion.div whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }}>
          <Link
            to="/"
            data-testid="deeplink-home-link"
            className="flex items-center gap-2 text-sm font-semibold text-[#1A1A1A] hover:text-[#FF6B35] transition-colors duration-300"
          >
            <Smartphone className="w-4 h-4" />
            Scopri l'app
            <ArrowRight className="w-4 h-4" />
          </Link>
        </motion.div>
      </motion.div>
    </div>
  );
}
